import './Footer.css'
export default function Footer() {
	return (
		<div className='Footer w-full min-h-60 bg-slate-800 mt-40 pb-10'>
			<div className="footer-content flex flex-col lg:flex-row lg:w-3/4 w-full mx-auto pt-10">
				<div className="contacts grow shrink basis-0 mx-auto">
					<div className="insta">
						<img src="https://img.icons8.com/fluency/30/000000/instagram-new.png" className='pr-2'/> 
						<a href="https://www.instagram.com/mol3sz/">Instagram</a> 
					</div>
					<div className="facebook">
						<img src="https://img.icons8.com/fluency/30/000000/facebook-new.png" className='pr-2'/>
						<a href="https://www.facebook.com/moleszkrisa/">Facebook</a> 
					</div>
					<div className="facebook">
						<img src="https://img.icons8.com/color/30/000000/linkedin.png" className='pr-2'/>
						<a href="https://www.linkedin.com/in/krist%C3%B3f-moln%C3%A1r-a99b79218/">Linkedin</a> 
					</div>
					<div className="insta">
						<img src="https://img.icons8.com/ios-glyphs/30/ffffff/github.png" className='pr-2'/>
						<a href="https://github.com/mol3sz">Github</a> 
					</div>
				</div>
				<div className="2 grow shrink basis-0">
					<p className='text-xl font-medium underline text-center'>Inspired by</p>
					<div className="insp-cont w-fit mx-auto text-lg mt-2">
						<span className='inspired mr-2'>Firebase.com</span>
						<span className='inspired'>React (Typscript)</span>
					</div>
					<div className="fot-desc mt-3 mx-auto md:text-justify w-fit text-center">
						I would like to mention these two helpful technolgies, which helped me to build this site.
					</div>

				</div>
				<div className="copyright grow shrink basis-0 text-center"
				>
					<p>© Copyright 2021 Molnár Kristóf</p>
				</div>

			</div>
		</div>
	)
}